import { render, staticRenderFns } from "./LittleBIndex.vue?vue&type=template&id=1fe6987e&scoped=true"
import script from "./LittleBIndex.vue?vue&type=script&lang=js"
export * from "./LittleBIndex.vue?vue&type=script&lang=js"
import style0 from "./LittleBIndex.vue?vue&type=style&index=0&id=1fe6987e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe6987e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe6987e')) {
      api.createRecord('1fe6987e', component.options)
    } else {
      api.reload('1fe6987e', component.options)
    }
    module.hot.accept("./LittleBIndex.vue?vue&type=template&id=1fe6987e&scoped=true", function () {
      api.rerender('1fe6987e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/riskControl/LittleBIndex.vue"
export default component.exports